"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Preloader.css");
var Preloader = (function (_super) {
    __extends(Preloader, _super);
    function Preloader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Preloader.prototype.render = function () {
        var _a = this.props, isVisible = _a.isVisible, tag = _a.tag;
        var className = 'p-preloader';
        if (!isVisible) {
            className += ' is-hidden';
        }
        return (React.createElement("div", { className: className, "data-tag": tag },
            React.createElement("div", { className: "spinner" })));
    };
    return Preloader;
}(React.Component));
Preloader.defaultProps = {
    isVisible: false,
    tag: null
};
exports.default = Preloader;
//# sourceMappingURL=Preloader.js.map


//////////////////
// WEBPACK FOOTER
// ../player-preloader/build/control/Preloader.js
// module id = 542
// module chunks = 0